
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return require("private-next-pages/privacy.tsx");
      }
    ]);
  